import { defineMessages } from 'react-intl';

export default defineMessages({
    baDriverAssignmentTitle: {
        id: 'quoteandbind.rv.directives.templates.rv-driver-assignment.Vehicle',
        defaultMessage: 'Vehicle',
    },
    baDriverAssignmentAdd: {
        id: 'quoteandbind.rv.directives.templates.rv-driver-assignment.Add Driver Assignment',
        defaultMessage: 'Add Driver Assignment',
    },
    baDriverAssignmentDriver: {
        id: 'quoteandbind.rv.directives.templates.rv-driver-assignment.Driver',
        defaultMessage: 'Driver',
    },
    baDriverAssignmentTitleLatest: {
        id: 'quoteandbind.rv.directives.templates.rv-driver-assignment.Driver Assignment',
        defaultMessage: 'Driver Assignment',
    },
    baDriverAssignmentYears: {
        id: 'quoteandbind.rv.directives.templates.rv-driver-assignment.Years of Experience',
        defaultMessage: 'Years of Experience',
    },
    baDriverAssignmentRateable: {
        id: 'quoteandbind.rv.directives.templates.rv-driver-assignment.Rateable Occasional Driver',
        defaultMessage: 'Rateable Occasional Driver',
    },
    baDriverAssignmentRemove: {
        id: 'quoteandbind.rv.directives.templates.rv-driver-assignment.Remove',
        defaultMessage: 'Remove',
    },
    driverAssignmentVehicleUseHeader: {
        id: 'quoteandbind.rv.directives.templates.rv-driver-assignment.Vehicle Use',
        defaultMessage: 'Vehicle Use',
    }
});
